export default {
  methods: {
    langPrefix: function (url) {
      if (url[0] !== '/') {
        throw new Error('langPrefix helper requires absolute paths.')
      }
      // Mapping language to Url Prefix.
      const LANGUAGE_PREFIX = {
        en: '',
        de: '/de'
      };
      return `${LANGUAGE_PREFIX[this.lang]}${url}`
    }
  }
};
